const BASE_URL = 'https://contacts-json-api.herokuapp.com/';
async function fetchWithErrorHandling(url = '', config = {}) {
  const response = await fetch(url, config);
  return response.ok
    ? await response.json()
    : Promise.reject(new Error('Some thing went wrong!'));
}
export function getForm() {
  return fetchWithErrorHandling(`${BASE_URL}form/`);
}
export function setForm(form) {
  return fetchWithErrorHandling(`${BASE_URL}form/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: `${form}`,
  });
}
